import { createGetFullKeyEndpointFromExisting } from '@lib';
import { getFollowed } from './getFollowed';

export const getAllFollowed = createGetFullKeyEndpointFromExisting(getFollowed);
